import HeaderPreview from "./HeaderPreview";
import DownloadResume from "../about/DownloadResume";
import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

const Mainpage = () => {
  useEffect(() => {
    document.title = "Zoe-Alanah Robert";
  })
  return (
    <article className="main-page">
      <HeaderPreview />
      <DownloadResume />
      <ScrollButton />
    </article>
  );
};

export default Mainpage;
